export default __webpack_public_path__ + "images/48bcb665afb39929cf3af9b0e9480592.png";